var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-card",
    { attrs: { bordered: false } },
    [
      _c(
        "div",
        { staticClass: "table-page-search-wrapper" },
        [
          _c(
            "a-form",
            { attrs: { layout: "inline" } },
            [
              _c(
                "a-row",
                { attrs: { gutter: 24 } },
                [
                  _c(
                    "a-col",
                    { attrs: { md: 6, sm: 24 } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: "订单号" } },
                        [
                          _c("a-input", {
                            attrs: { placeholder: "请输入订单号" },
                            model: {
                              value: _vm.queryParam.orderCode,
                              callback: function($$v) {
                                _vm.$set(_vm.queryParam, "orderCode", $$v)
                              },
                              expression: "queryParam.orderCode"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { md: 6, sm: 24 } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: "订单类型" } },
                        [
                          _c(
                            "a-select",
                            {
                              attrs: { placeholder: "请输入订单类型" },
                              model: {
                                value: _vm.queryParam.ctype,
                                callback: function($$v) {
                                  _vm.$set(_vm.queryParam, "ctype", $$v)
                                },
                                expression: "queryParam.ctype"
                              }
                            },
                            [
                              _c("a-select-option", { attrs: { value: "1" } }, [
                                _vm._v("国内订单")
                              ]),
                              _c("a-select-option", { attrs: { value: "2" } }, [
                                _vm._v("国际订单")
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c("a-col", { attrs: { md: 6, sm: 24 } }, [
                    _c(
                      "span",
                      {
                        staticClass: "table-page-search-submitButtons",
                        staticStyle: { float: "left", overflow: "hidden" }
                      },
                      [
                        _c(
                          "a-button",
                          {
                            attrs: { type: "primary", icon: "search" },
                            on: { click: _vm.searchQuery }
                          },
                          [_vm._v("查询")]
                        ),
                        _c(
                          "a-button",
                          {
                            staticStyle: { "margin-left": "8px" },
                            attrs: { type: "primary", icon: "reload" },
                            on: { click: _vm.searchReset }
                          },
                          [_vm._v("重置")]
                        )
                      ],
                      1
                    )
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "table-operator" },
        [
          _c(
            "a-button",
            {
              attrs: { type: "primary", icon: "plus" },
              on: { click: _vm.handleAdd }
            },
            [_vm._v("新增")]
          ),
          _vm.selectedRowKeys.length > 0
            ? _c(
                "a-dropdown",
                [
                  _c(
                    "a-menu",
                    { attrs: { slot: "overlay" }, slot: "overlay" },
                    [
                      _c(
                        "a-menu-item",
                        { key: "1", on: { click: _vm.batchDel } },
                        [
                          _c("a-icon", { attrs: { type: "delete" } }),
                          _vm._v("\n          删除\n        ")
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-button",
                    { staticStyle: { "margin-left": "8px" } },
                    [
                      _vm._v(" 批量操作\n        "),
                      _c("a-icon", { attrs: { type: "down" } })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "div",
        [
          _c(
            "div",
            {
              staticClass: "ant-alert ant-alert-info",
              staticStyle: { "margin-bottom": "16px" }
            },
            [
              _c("i", {
                staticClass: "anticon anticon-info-circle ant-alert-icon"
              }),
              _vm._v(" 已选择 "),
              _c("a", { staticStyle: { "font-weight": "600" } }, [
                _vm._v(_vm._s(_vm.selectedRowKeys.length))
              ]),
              _vm._v("项\n      "),
              _c(
                "a",
                {
                  staticStyle: { "margin-left": "24px" },
                  on: { click: _vm.onClearSelected }
                },
                [_vm._v("清空")]
              )
            ]
          ),
          _c("a-table", {
            ref: "table",
            attrs: {
              size: "middle",
              bordered: "",
              rowKey: "id",
              filterMultiple: "filterMultiple",
              columns: _vm.columns,
              dataSource: _vm.dataSource,
              pagination: _vm.ipagination,
              loading: _vm.loading,
              rowSelection: {
                selectedRowKeys: _vm.selectedRowKeys,
                onChange: _vm.onSelectChange,
                type: _vm.type
              },
              customRow: _vm.clickThenCheck
            },
            on: { change: _vm.handleTableChange },
            scopedSlots: _vm._u([
              {
                key: "action",
                fn: function(text, record) {
                  return _c(
                    "span",
                    {},
                    [
                      _c(
                        "a",
                        {
                          on: {
                            click: function($event) {
                              return _vm.handleEdit(record)
                            }
                          }
                        },
                        [_vm._v("编辑")]
                      ),
                      _c("a-divider", { attrs: { type: "vertical" } }),
                      _c(
                        "a-popconfirm",
                        {
                          attrs: { title: "确定删除吗?" },
                          on: {
                            confirm: function() {
                              return _vm.handleDelete(record.id)
                            }
                          }
                        },
                        [_c("a", [_vm._v("删除")])]
                      )
                    ],
                    1
                  )
                }
              }
            ])
          })
        ],
        1
      ),
      _c(
        "a-tabs",
        { attrs: { defaultActiveKey: "1" } },
        [
          _c(
            "a-tab-pane",
            { key: "1", attrs: { tab: "客户信息" } },
            [
              _c("Jeecg-Order-Customer-List", { ref: "JeecgOrderCustomerList" })
            ],
            1
          ),
          _c(
            "a-tab-pane",
            { key: "2", attrs: { tab: "机票信息", forceRender: "" } },
            [_c("Jeecg-Order-Ticket-List", { ref: "JeecgOrderTicketList" })],
            1
          )
        ],
        1
      ),
      _c("jeecgOrderDMain-modal", {
        ref: "modalForm",
        on: { ok: _vm.modalFormOk }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }